import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import CustomSelect from '../../components/atoms/custom-select';
import { DMDropdownStyle } from '../../styles';
import { useTranslation } from 'react-i18next';

//Left Panel for Dept Management page. Showing on UI but this page is of no use as of now
const LeftPanel = props => {
  const {
    onRefreshClick,
    handleSearchChange,
    siteListData,
    departmentListData,
  } = props;
  const { t } = useTranslation();
  const [dropdownValue, setDropdownValue] = useState({
    siteLabel: '',
    siteValue: '',
    departmentValue: '',
    departmentLabel: '',
  });

  //options for Site drop-down
  const siteOptions =
    siteListData.length > 0
      ? siteListData.map(list => {
          return {
            label: list.SiteName,
            value: list.ID,
          };
        })
      : [];

  //options for Department drop-down
  const departmentOptions =
    departmentListData.length > 0
      ? departmentListData.map(list => {
          return {
            label: list.Name,
            value: list.ID,
          };
        })
      : [];

  //To handle the onChange functionality of drop-down
  const handleDropdownChange = (event, value, label) => {
    setDropdownValue({
      ...dropdownValue,
      [value]: event && event.value ? event.value.toString() : '',
      [label]: event && event.label ? event.label.toString() : '',
    });
  };

  const handleRefreshClick = () => {
    onRefreshClick(dropdownValue);
  };

  return (
    <Grid>
      <InputTextField
        name={'SearchBox'}
        placeholder={`${t('User_Search')}...`}
        style={{
          padding: '10px 10px 10px 10px',
          marginBottom: '10px',
          width: '300px',
        }}
        onChange={event => handleSearchChange(event)}
      />
      <CustomSelect
        name={'site'}
        id={'site'}
        placeholder={t('Site')}
        options={siteOptions}
        styles={DMDropdownStyle}
        onChange={event =>
          handleDropdownChange(event, 'siteValue', 'siteLabel')
        }
      />
      <CustomSelect
        name={'department'}
        id={'department'}
        placeholder={t('Department')}
        options={departmentOptions}
        styles={DMDropdownStyle}
        onChange={event =>
          handleDropdownChange(event, 'departmentValue', 'departmentLabel')
        }
      />
      <Button
        variant="contained"
        style={{
          textTransform: 'none',
          width: '300px',
          height: '50px',
          marginBottom: '10px',
          fontSize: '16px',
        }}
        onClick={handleRefreshClick}
      >
        {t('Refresh_User_Table')}
      </Button>
    </Grid>
  );
};

export default LeftPanel;
